import * as React from "react";
import { useCallback, useImperativeHandle, useState } from "react";
import { Formik, Form, Field } from "formik";
import { ModalSubmit, Spinner } from "components/common";
import { HelpBlock, Modal } from "components/bootstrap";
import useCollectionMutation from "collections/hooks/useCollectionMutation";
import { createGRN, getValuesFromGRN } from "logic/permissions/GRN";
import useEntityCollections from "collections/hooks/useEntityCollections";
import AddCollectionFormGroup from "./AddCollectionFormGroup";
const getRequestPayload = (selectedCollections, initialValues) => {
  var _a, _b;
  const newValues = (selectedCollections == null ? void 0 : selectedCollections.filter((str) => str !== "")) || [];
  const prevOptions = initialValues;
  const added = (_a = newValues == null ? void 0 : newValues.filter((val) => !prevOptions.some((prev) => prev === val))) != null ? _a : [];
  const removed = (_b = prevOptions == null ? void 0 : prevOptions.filter((val) => !newValues.some((curr) => curr === val))) != null ? _b : [];
  return { addTo: added.map((a) => getValuesFromGRN(a).id), removeFrom: removed.map((r) => getValuesFromGRN(r).id) };
};
const EntityCollectionModal = React.forwardRef(
  ({
    entityId,
    entityType,
    title: modalTitle,
    submitButtonText = "Save",
    submitLoadingText = "Saving...",
    show = false,
    onClose = () => {
    }
  }, ref) => {
    var _a;
    const [showModal, setShowModal] = useState(show);
    const entityGRN = createGRN(entityType, entityId);
    const { data: entityCollections, isLoading } = useEntityCollections([entityGRN], { enabled: showModal });
    const { updateEntityCollectionsMutation } = useCollectionMutation();
    useImperativeHandle(ref, () => ({
      toggle: () => setShowModal(true)
    }));
    const closeModal = useCallback(() => {
      setShowModal(false);
      if (onClose) onClose();
    }, [onClose]);
    const initialValues = {
      selected_collections: (_a = entityCollections == null ? void 0 : entityCollections[entityId]) == null ? void 0 : _a.map((collection) => createGRN("collection", collection.id))
    };
    const handleSubmit = useCallback(
      (values) => updateEntityCollectionsMutation({
        entityId: createGRN(entityType, entityId),
        payload: getRequestPayload(values.selected_collections, initialValues.selected_collections)
      }).then(() => closeModal()),
      [entityId, entityType, closeModal, updateEntityCollectionsMutation, initialValues.selected_collections]
    );
    return /* @__PURE__ */ React.createElement(Modal, { onHide: closeModal, show: showModal }, isLoading ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading entity collections." }) : /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit }, ({ isSubmitting, isValidating, setFieldValue }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Field, { name: "selected_collections" }, ({ field: { value } }) => /* @__PURE__ */ React.createElement(
      AddCollectionFormGroup,
      {
        label: "",
        hideHelp: true,
        entityType,
        onChange: (selected) => setFieldValue("selected_collections", selected.selected_collections),
        value
      }
    )), /* @__PURE__ */ React.createElement(HelpBlock, null, `Select the collections in which this ${entityType} will be added to. The ${entityType} will be removed from collections you deselect. You can create collections in the collections page`)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText,
        submitLoadingText,
        onCancel: closeModal,
        disabledSubmit: isValidating,
        isSubmitting
      }
    )))));
  }
);
export default EntityCollectionModal;
